// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__33xcy","container":"styles_container__3OpyG","title":"styles_title__3GtcM","wrapper":"styles_wrapper__K1iOh","answer":"styles_answer__1kyBr"};